import React from 'react';
// import "./ReasonRow.scss";
import { Row, Col } from 'reactstrap';

const ReasonRow = (props) => {
    return (
        <Row><Col xs={{ size: 'auto', offset: 1 }}><img className="o-check" alt="img" src="content/images/landing-page/o-check.svg" width="19" height="15" /></Col><Col><span>{props.text}</span></Col></Row>
    )
}
export default ReasonRow;